// EmailJS Configuration
// You need to sign up at https://www.emailjs.com/ and get your own credentials
// Then update these values in your .env file

export const EMAILJS_CONFIG = {
  SERVICE_ID: process.env.REACT_APP_EMAILJS_SERVICE_ID || 'your_service_id',
  PUBLIC_KEY: process.env.REACT_APP_EMAILJS_PUBLIC_KEY || 'your_public_key',

  // Template IDs for different notification types
  TEMPLATES: {
    NEW_ADMIN_NOTIFICATION: process.env.REACT_APP_EMAILJS_TEMPLATE_NEW_ADMIN || 'template_new_admin',
    NEW_BOOK_NOTIFICATION: process.env.REACT_APP_EMAILJS_TEMPLATE_NEW_BOOK || 'template_new_book',
    WELCOME_ADMIN: process.env.REACT_APP_EMAILJS_TEMPLATE_WELCOME || 'template_welcome_admin',
  },
};
